import { types } from "../types/types";

const initialState = {
  listContinents: [],
  listRegions: [],
  listCountries: [],

  listFullRegions: [],
  listFullCountries: [],

  country: {},

  objectContinentSelected: {},
  objectRegionSelected: {},
  objectCountrySelected: {},

  objectContinentSelectedInitial: {},
  objectRegionSelectedInitial: {},
  objectCountrySelectedInitial: {},

  catalog: {},
  catalogs: [],
  catalogsP: [],
  catalogsS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
};
export const locationCountryReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOCATIONCOUNTRY_START_LOADING_CONTINENT:
      
      return {
        ...state,
        listContinents: action.payload,
      };

    case types.LOCATIONCOUNTRY_SELECT_CONTINENT:
      return {
        ...state,
        objectContinentSelected: action.payload,
      };

      case types.LOCATIONCOUNTRY_SELECT_CONTINENT_INITIAL:
      return {
        ...state,
        objectContinentSelectedInitial: action.payload,
      };

    case types.LOCATIONCOUNTRY_START_LOADING_REGION:
      return {
        ...state,
        listRegions: action.payload,
      };

      case types.LOCATIONCOUNTRY_START_LOADING_REGION_ALL:
      return {
        ...state,
        listFullRegions: action.payload,
      };

    case types.LOCATIONCOUNTRY_SELECT_REGION:
      return {
        ...state,
        objectRegionSelected: action.payload,
      };

      case types.LOCATIONCOUNTRY_SELECT_REGION_INITIAL:
      return {
        ...state,
        objectRegionSelectedInitial: action.payload,
      };

    case types.LOCATIONCOUNTRY_START_LOADING_COUNTRY:
      return {
        ...state,
        listCountries: action.payload,
      };

      case types.LOCATIONCOUNTRY_START_LOADING_COUNTRY_ALL:
      return {
        ...state,
        listFullCountries: action.payload,
      };

    case types.LOCATIONCOUNTRY_SELECT_COUNTRY:
      return {
        ...state,
        objectCountrySelected: action.payload,
      };

      case types.LOCATIONCOUNTRY_SELECT_COUNTRY_INITIAL:
        return {
          ...state,
          objectCountrySelectedInitial: action.payload,
        };

    case types.LOCATIONCOUNTRY_CLEAN_CONTINENT:
      return {
        ...state,
        objectRegionSelected: {},
        listRegions: [],
        objectCountrySelected: {},
        listCountries: [],
      };

    case types.LOCATIONCOUNTRY_CLEAN_REGION:
      return {
        ...state,
        objectCountrySelected: {},
        listCountries: [],
      };

    /*
      case types.LOCATIONCOUNTRY_START_LOADING_ONE_COUNTRY:
        return {
          ...state,
          country: action.payload,
        };
      */

        case types.LOCATIONCOUNTRY_START_LOADING_FILTER:

              if (action.payload == null || typeof action.payload !== 'object') {
                return state;
              }

              const { catalogcontinents_ids, catalogregions_ids, catalogcountries_ids } = action.payload;
        
              const catalogContinentIdsList = catalogcontinents_ids && catalogcontinents_ids.split(",");
              const catalogRegionsIdsList = catalogregions_ids && catalogregions_ids.split(",");
              const catalogCountriesIdsList = catalogcountries_ids && catalogcountries_ids.split(",");

              return {
                ...state,
        
                listContinentsFilter: getFilterCatalog(state.listContinents, catalogContinentIdsList),
                listRegionsFilter: getFilterCatalog(state.listFullRegions, catalogRegionsIdsList),
                listCountriesFilter: getFilterCatalog(state.listFullCountries, catalogCountriesIdsList),
        
              };

    default:
      return state;
  }
};

const getFilterCatalog = (arrayFull, uniqueArray) => {
  
  let listFilterCatalog = [];

  if (uniqueArray) {

    for (const idUniqueFound of uniqueArray) {
      for (const elemSearch of arrayFull) {
        
        if (parseInt(idUniqueFound) === elemSearch.id) {
          
          elemSearch.isChecked = false;
          listFilterCatalog.push(elemSearch);
        }
      }
    }

  }

  listFilterCatalog.sort((a, b) => a.id - b.id)

  return listFilterCatalog;

}
